<template>
  <div class="deposit-order-description c:row-start-center">
    <span class="deposit-order-description-label">{{ label }}</span>
    <div
      v-if="editable"
      class="deposit-order-description-modifier c:row-start-center"
      @click="throttledOnEditClick"
    >
      <img src="@/assets/icons/edit.svg" alt="" /><span>修改</span>
    </div>
    <span class="deposit-order-description-value">{{ computedValue }}</span>
    <span
      v-if="copiable"
      class="deposit-order-description-tail c:row-end-center"
      v-clipboard:copy="value"
      v-clipboard:success="onCopy"
    >
      <img src="@/assets/icons/copy-dark.svg" alt="" />
    </span>
  </div>
</template>

<script>
import { outputmoney, throttle } from "@/utils";

export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    timeFormat: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss",
    },
    copiable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { images: [] };
  },
  created() {
    this.throttledOnEditClick = throttle(() => this.$emit("edit"), 500);
  },
  computed: {
    computedValue() {
      switch (this.type) {
        case "images":
          return ``;

        case "amount":
          return `¥ ${outputmoney(this.value)}`;

        case "time":
          return this.$moment(this.value).format(
            this.timeFormat || "YYYY-MM-DD HH:mm:ss"
          );

        default:
          return this.value;
      }
    },
  },

  mounted() {},
  methods: {
    onCopy() {
      this.$toast("复制成功");
    },
  },
};
</script>

<style lang="less" scoped>
.deposit-order-description {
  gap: 10/20rem;

  min-height: 52/20rem;
  padding: 10/20rem 0;
  border-bottom: 1px solid #e8e8e8;

  line-height: 17/20rem;
  font-size: 12/20rem;
  font-weight: 400;
  letter-spacing: 0;

  &:last-of-type {
    border-bottom: none;
  }

  &-label {
    // min-width: 80/20rem;
    text-align: left;
    color: #666;
  }

  &-modifier {
    gap: 6/20rem;
    color: #333;
  }

  &-value {
    flex: 1;
    width: 0;
    text-align: right;
    color: #333;
  }

  &-tail {
    img {
      width: 12/20rem;
      height: 12/20rem;
    }
  }
}
</style>
